import React, {Component} from 'react';
import AppNavigation from '../AppNavigation';
import AppFooter from '../AppFooter';
import SubSubmissions from '../Subcomponents/Submissions';
import withRouter from '../Functions/WithRouter';

class OrgSubmissions extends Component {
    constructor(props) {
      super(props)

      this.state = {
      }
    }

    componentDidMount(){
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      const { org } = this.props.params

      let email = localStorage.getItem('email');
      let roleName = localStorage.getItem('roleName');
      let activeOrg = localStorage.getItem('activeOrg');
      let username = localStorage.getItem('username');
      let orgFocus = localStorage.getItem('orgFocus');
      const orgLogo = localStorage.getItem('orgLogo');

      this.setState({ orgCode: org, org, emailId: email, username, orgFocus, roleName, orgLogo })

    }

    render() {

        return (
          <div>
            <AppNavigation fromOrganization={true} org={this.state.org} orgFocus={this.state.orgFocus} />
            <SubSubmissions email={this.state.emailId} activeOrg={this.state.activeOrg} orgFocus={this.state.orgFocus} roleName={this.state.roleName} passActiveOrg={this.passActiveOrg} history={this.props.navigate} />

            {(this.state.org && !this.state.hideHelpPrompt) && (
              <div>
                {AppFooter(this.props.navigate,this.state.activeOrg,this.state.orgLogo,this.state.passedCommand, this.state.hideNav)}
              </div>
            )}
          </div>

        )
    }
}

export default withRouter(OrgSubmissions)
